import posthog from "posthog-js";
import { getOrCreateDeviceId } from "@/lib/identity";

export type FillsSuggestionDismissMethod = "keep_mist" | "close";

export interface FillsSuggestionData {
  originalVariantId: number;
  suggestedVariantId: number;
  quantity: number;
}

type FillsSuggestionEvent =
  | "cart.fills_suggestion.shown"
  | "cart.fills_suggestion.accepted"
  | "cart.fills_suggestion.dismissed";

function publishFillsSuggestion(
  event: FillsSuggestionEvent,
  data: FillsSuggestionData & { method?: FillsSuggestionDismissMethod },
): void {
  if (typeof window === "undefined") return;
  const properties: Record<string, unknown> = {
    original_variant_id: data.originalVariantId,
    suggested_variant_id: data.suggestedVariantId,
    quantity: data.quantity,
  };
  if (data.method) properties.method = data.method;
  try {
    const payload = {
      event_type: event,
      visitorId: getOrCreateDeviceId(),
      url: window.location.href,
      properties,
    };
    window.Shopify?.analytics?.publish?.(event, payload);
  } catch {
    /* pixel publish is best-effort */
  }
  try {
    posthog.capture(event, properties);
  } catch {
    /* posthog is best-effort */
  }
}

export function trackFillsSuggestionShown(data: FillsSuggestionData): void {
  publishFillsSuggestion("cart.fills_suggestion.shown", data);
}

export function trackFillsSuggestionAccepted(data: FillsSuggestionData): void {
  publishFillsSuggestion("cart.fills_suggestion.accepted", data);
}

export function trackFillsSuggestionDismissed(
  data: FillsSuggestionData & { method: FillsSuggestionDismissMethod },
): void {
  publishFillsSuggestion("cart.fills_suggestion.dismissed", data);
}
